<template>
  <div ref="portalPageRef" class="portal-page">
    <!-- ZJSClaw 页自带 HTML 顶栏，隐藏门户 Navbar -->
    <PortalNavbar v-if="!hidePortalChrome" />
    <div v-if="!hidePortalChrome" class="navbar-spacer"></div>

    <!-- 门户子页面路由出口（勿用 mode=out-in：卸旧页与挂新页之间会出现整页空白） -->
    <router-view v-slot="{ Component }">
      <component :is="Component" :key="route.path" />
    </router-view>

    <!-- 共享页脚（含 ZJSClaw） -->
    <PortalFooter />

    <!-- 全局弹窗 -->
    <LoginModal />
    <SearchModal />
    <TrialModal />
  </div>
</template>

<script lang="ts" setup>
import PortalNavbar from './PortalNavbar.vue'
import PortalFooter from './PortalFooter.vue'
import LoginModal from './LoginModal.vue'
import SearchModal from './SearchModal.vue'
import TrialModal from './TrialModal.vue'

defineOptions({ name: 'Login' })

const route = useRoute()
const portalPageRef = ref<HTMLElement | null>(null)

/** ZJSClaw 落地页用 HTML 原顶栏，不叠门户 Navbar */
const hidePortalChrome = computed(() => route.path === '/portal/zjsclaw')

function resetPortalScroll() {
  const el = portalPageRef.value
  if (el) el.scrollTop = 0
  // 兼容个别浏览器把滚动落在 document 上的情况
  window.scrollTo(0, 0)
}

/**
 * 方案详情等长页在 .portal-page 内滚动；顶栏切到首页/其它页时若不回顶，
 * 会停在空白区，看起来像「只有头尾」。新窗口打开详情后再切页同理。
 */
watch(
  () => route.fullPath,
  async () => {
    resetPortalScroll()
    await nextTick()
    resetPortalScroll()
    requestAnimationFrame(() => resetPortalScroll())
  }
)

onMounted(() => {
  resetPortalScroll()
})
</script>

<style lang="scss" scoped>
.portal-page {
  /* 继承 #app 高度作滚动容器，避免 iPad Safari 下 100vh 裁切页脚 */
  height: 100%;
  min-height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}

.navbar-spacer {
  height: 60px;
}

@media (max-width: 700px) {
  .navbar-spacer {
    height: 56px;
  }
}
</style>
